













import { Component, Prop, Vue } from 'vue-property-decorator';
import { IIntroNavItem } from '@/models/intro-nav';

@Component({
  name: 'intro-nav',
})
export default class IntroNav extends Vue {
  public navItems: IIntroNavItem[] = [
    {
      title: '产品介绍',
      href: '#product-intro',
    }, {
      title: '团队介绍',
      href: '#team-intro',
    }, {
      title: '加入我们',
      href: '#join-us',
    }, {
      title: '联系我们',
      href: '#contact-us',
    }];
  @Prop(String) private activeItem!: string;

  public get isActive(): boolean {
    return this.navItems.map((item) => item.title).indexOf(this.activeItem) >= 0;
  }
}
